import React, { useState } from "react";

const PlayerSettings = ({ onStart }) => {
  const [gridSize, setGridSize] = useState(0); // State to track the grid size

  const handleSettingsSubmit = (e) => {
    // console.log(e);
    e.preventDefault();
    onStart(gridSize);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-col border-4 border-theme-5 p-4 items-center">
        <h1 className="text-2xl mb-4 text-theme-2 font-medium">
          Select Grid Size
        </h1>
        <form onSubmit={handleSettingsSubmit} className="space-y-4">
          <select
            name="gridSize"
            className="w-full h-10 px-2 mt-1 bg-theme-5 text-theme-3 font-bold rounded-md shadow-sm"
            onChange={(e) => setGridSize(Number(e.target.value))}
          >
            <option value="0">0x0</option>
            <option value="2">2x2</option>
            <option value="3">3x3</option>
            <option value="4">4x4</option>
            <option value="5">5x5</option>
            <option value="6">6x6</option>
          </select>
          <button
            type="submit"
            className="px-4 w-full py-2 font-semibold bg-theme-2 md:bg-theme-5 hover:bg-theme-2 text-theme-3 rounded-md"
          >
            Start Game
          </button>
        </form>
      </div>
    </div>
  );
};

export default PlayerSettings;
